import { render, staticRenderFns } from "./screen2.vue?vue&type=template&id=3b9743e5&scoped=true&"
import script from "./screen2.vue?vue&type=script&lang=js&"
export * from "./screen2.vue?vue&type=script&lang=js&"
import style0 from "./screen2.vue?vue&type=style&index=0&id=3b9743e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9743e5",
  null
  
)

export default component.exports